
define('ChangeSKUForMasterPartNumber.EntryPoint',
	[
	],
	function (
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');

				if (layout) {
					layout.addToViewContextDefinition('ProductLine.Sku.View', 'sku', 'string', function(context) {
						return context.model && context.model.item ? context.model.item.custitem_masterpartref : context.sku;
					  });
				}

			}
		};
	});
